export default "__VITE_ASSET__CoKONvRa__"